var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChainSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "#52575C",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10 13c.43.574.977 1.05 1.607 1.393.629.344 1.325.548 2.04.6.715.05 1.433-.053 2.104-.303.672-.25 1.282-.643 1.789-1.15l3-3c.91-.943 1.415-2.206 1.403-3.517-.011-1.311-.537-2.565-1.464-3.492-.927-.927-2.181-1.453-3.492-1.464-1.311-.012-2.574.492-3.517 1.403l-1.72 1.71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13.998 11.001c-.43-.574-.977-1.049-1.606-1.393-.63-.344-1.325-.548-2.04-.6-.716-.05-1.433.053-2.105.303-.672.251-1.282.643-1.789 1.15l-3 3c-.91.943-1.415 2.206-1.403 3.517.011 1.311.537 2.565 1.464 3.492.927.927 2.181 1.453 3.492 1.465 1.311.011 2.574-.493 3.517-1.404l1.71-1.71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainSvg);
export default __webpack_public_path__ + "static/media/chainSvg.3f9f6f535d6dd97e006ab26d2ed7f10d.svg";
export { ForwardRef as ReactComponent };